"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function yfi(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.4075 16.7699V7.31543H12.4365V16.7699H11.4075Z", fill: color }),
        React.createElement("path", { d: "M16.6477 10.4654L13.4677 11.3084L12.759 8.00845L13.704 7.79545L14.0775 9.35845C14.0775 9.35845 14.9362 7.94995 13.791 6.49045C13.116 5.74045 12.7957 5.70895 12.039 5.59045C11.373 5.4952 9.825 5.7202 9.36375 7.52695C9.16875 8.69095 9.3885 9.55195 10.8885 10.6792L10.8045 11.9339C10.8045 11.9339 9.12975 10.7542 8.69775 9.92695C8.364 9.2722 7.79025 7.9792 8.82525 6.1792C9.38175 5.2792 10.4797 4.41595 12.414 4.5067C13.386 4.5472 15.7612 5.7367 15.393 8.5132C15.3292 9.0337 15.0592 9.7267 15.0592 9.7267L16.3642 9.43645L16.6477 10.4654ZM14.832 17.8635C14.25 18.7477 13.1295 19.5809 11.1997 19.4407C10.227 19.3747 7.88625 18.1222 8.32725 15.3562C8.4045 14.8387 8.69325 14.1539 8.69325 14.1539L7.3815 14.4089L7.125 13.3747L10.3275 12.6157L10.95 15.9337L9.9975 16.1227L9.666 14.5477C9.666 14.5477 8.7705 15.9314 9.87525 17.4225C10.5292 18.1904 10.848 18.2295 11.6047 18.3674C12.2662 18.4815 13.8202 18.2955 14.3295 16.5022C14.5545 15.3449 14.3565 14.4772 12.8887 13.3087L13.0065 12.0562C13.0065 12.0562 14.6497 13.2787 15.0592 14.1179C15.3727 14.7839 15.9112 16.0927 14.832 17.8635Z", fill: color }));
}
exports["default"] = yfi;
//# sourceMappingURL=yfi.js.map